angular.module('app').controller('DoisFatoresFormController', function ($scope, $http, $timeout, vcRecaptchaService) {
    $scope.form = {};
    $scope.urlDestino = '';
    $scope.validando = false;
    $scope.reenviando = false;

    $scope.reenviar = function(){
        if(!confirm('Será enviado um novo e-mail com um novo código de segurança que irá invalidar o anterior. Deseja continuar?')){
            return false;
        }

        $scope.reenviando = true;
        $http({
            'url': 'auth/2fatores/reenviar',
            'method': 'post',
            'data': $scope.form
        }).then(function(response){
            if(response.data.status){
                $timeout(function(){
                    $scope.reenviando = false;
                }, 60*1000);
                alert(response.data.msg);
            }else{
                $scope.reenviando = false;
            }
        }).catch(function(err){
            $scope.reenviando = false;
        });
    }

    $scope.setRecaptchaId = function (recaptchaId) {
        $scope.recaptchaId = recaptchaId;
    }

    $scope.recarregarRecaptcha = function () {
        if ($scope.recaptchaId !== undefined) {
            vcRecaptchaService.reload($scope.recaptchaId);
        }
    }

    $scope.validar = function(){
        $scope.validando = true;
        $http({
            'url': 'auth/2fatores',
            'method': 'post',
            'data': $scope.form
        }).then(function(response){
            if(response.data.status){
                window.location.href = $scope.urlDestino;
            }else{
                $scope.validando = false;
                $scope.recarregarRecaptcha();
            }
        }).catch(function(err){
            $scope.validando = false;
            $scope.recarregarRecaptcha();
        });
    }
})